import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { CaseService } from 'src/app/services/case.service';
import { StatsService } from 'src/app/services/stats.service';
import * as appData from '../shared/appData';

@Component({
    selector: 'stats-chart',
    templateUrl: './case-stats-chart.component.html',
})

export class StatsChartComponent implements OnInit {
    @Input() chartData: any;

    reportCols: any[];
    chartOptions: any;  // options used to customize chart layout, etc
    chartSections: [];
    myChartSection: any;
    allSectionsData: any;   // contains the data for ALL sections
    valChartOptions: any;
    assessorChartOptions: any;
    //
    pieChartData: any;
    dynoChartData: any;
    valueDiffData: any;
    pieValueDiffData: any;
    assessorData: any;
    //
    chartType = 'bar';
    dsColors = ['red', 'black', 'green', 'blue', 'aqua', 'pink', 'violet', 'yellow', 'grey', '#1C39BB', '#FFE5B4', 'purple', '#0095B6', '#DE5D83', 'gold', '#0047AB', '#E0B0FF', 'magenta', 'aqua'];
    yearList: number[];
    cityList: string[];
    assessorList: any[];
    myYear = 0;
    displayState: any = {
        workingDiv: false,
        gridDiv: false,
        chartDiv: false,
        chartDivDyno: false,
        returnDiv: true,
        valDiffDiv: false
    };

    excelCols = appData.excelColList;  // column names used when exporting to Excel
    isDeveloper = this.utilService.isDeveloper();
    // temp vars used in fixing date closed issue
    fixYear = 0;
    //
    constructor(private utilService: UtilitiesService, private caseService: CaseService,
                private dictService: DictionaryService, private statsService: StatsService) {}

    ngOnInit() {
        this.utilService.doAudit('Charts init...');
        // localStorage.removeItem(this.cookieService.get('userName') + '-lastApplicant');
        this.myYear = (new Date()).getFullYear();
        this.populateYearList();
        this.reportCols = [
            { field: 'repDesc', header: 'Report Description' },
        ];
        this.chartOptions = {
            title: {
                display: true,
                text: 'Case Statistics',
                fontSize: 16
            },
            legend: {
                position: 'top'
            }
        };
        this.valChartOptions = {
            title: {
                display: true,
                text: 'Value Difference Stats',
                fontSize: 16
            },
            legend: {
                position: 'top'
            }
        };
        this.assessorChartOptions = {
          title: {
            display: true,
            text: 'Assessor Stats',
            fontSize: 16
          },
          legend: {
            position: 'top'
          }
        };

        this.chartData = {};
        this.pieChartData = {};
        this.valueDiffData = {};
        this.assessorData = {};
        //
        const dicts = this.dictService.getDictionaries(); // get all dictionaries
        this.utilService.doAudit(dicts, 'dictionaries');
        this.cityList = dicts.cityChoices;
        this.cityList.push('Other');
        //
        this.dictService.getAssessorList().subscribe(data => {
          this.utilService.doAudit(data, 'assessors:');
          this.assessorList = [];
          if (data) {
            // tslint:disable-next-line:prefer-for-of
            for (let ai = 0; ai < data.length; ai++) {
              this.assessorList.push(data[ai].name);
            }
            this.assessorList.push('Other');
          }
          this.utilService.doAudit(this.assessorList, 'assessor list:');
          this.runCaseStatsReport();
          this.displayState.chartDiv = true;
        });
        //
        // this.getChartDataL();   // get the data from local storage
    }

    runCaseStatsReport() {
      if (!this.myYear) {
        alert('Please select a Roll Year!');
        return;
      }
      // this.getReportData(this.myYear);
      this.getReportDataFromView(this.myYear);
    }

    // get application/case data from the vwCaseListingInfo view
    getReportDataFromView(caseYear: number): void {
      const srcObj = {
        p0: '',
        p1: '',
        p2: ''
      };
      this.utilService.doAudit(srcObj, 'report search:');
      this.displayState.workingDiv = true;
      this.displayState.chartDiv = false;
      // get list of cases based on the Property Roll Year (NOT when they were filed, i.e. case # based)
      // this.statsService.searchAppsByCaseYear(caseYear).subscribe(data => {
      this.statsService.searchApplicationsByYear(caseYear).subscribe(data => {
        this.utilService.doAudit(data, 'results from searchApplicationsByYear:');
        this.allSectionsData = data;
        this.chartOptions.title.text = 'Case Statistics for ' + caseYear + ' - by Status';
        this.valChartOptions.title.text = 'Value Differences for ' + caseYear;
        let caseObj: any = null;
        let city = '';
        let closedStat: boolean;
        let cityIdx = -1;
        let appraiserName = '';
        let appraiserId = 0;
        let assessIdx: any;
        const openCase = [];
        const otherCase = [];
        //
        const openCaseAssessor = [];
        const otherCaseAssessor = [];

        // initialize city counters for each dataset (openCase, otherCase, etc)
        const caseIds = [];
        const caseIdsByCity = [];
        for (let i = 0; i < this.cityList.length; i++) {
          openCase[i] = 0;
          otherCase[i] = 0;
        }
        for (let i = 0; i < this.assessorList.length; i++) {
          openCaseAssessor[i] = 0;
          otherCaseAssessor[i] = 0;
        }
        // update city counters for each dataset...
        for (let i = 0; i < data.length; i++) {
          caseObj = data[i];
          city = data[i].propCity;
          closedStat = data[i].closedStatus;
          appraiserId = data[i].assessorId;
          appraiserName = data[i].appraiserName;
          //
          // assessIdx = this.assessorList.filter(o => o.id === assessorId);  // if assessorList is an array of Objects!
          assessIdx = this.assessorList.indexOf(appraiserName);
          // this.utilService.doAudit(assessIdx, 'assessIdx for ' + appraiserName + ':');
          if (assessIdx < 0) {
            assessIdx = this.assessorList.length - 1; // default to "Other"
          }
          //
          cityIdx = this.cityList.indexOf(city);
          if (cityIdx < 0) {
            cityIdx = this.cityList.length - 1; // default to "Other"
          }
          if (closedStat === false) {
            openCase[cityIdx]++;
            openCaseAssessor[assessIdx]++;
          } else {
            otherCase[cityIdx]++;
            otherCaseAssessor[assessIdx]++;
          }
          caseIds.push(data[i].applicationId);
          caseIdsByCity.push(cityIdx);
        }
        this.utilService.doAudit(openCase, 'open cases totals');
        this.utilService.doAudit(otherCase, 'other cases totals');
        this.chartSections = [];
        this.myChartSection = 1;
        const tDS = [
          {
            label: 'Open Cases',
            data: openCase,
            fill: false,
            borderColor: '#4bc0c0',
            backgroundColor: '#42A5F5',
          },
          {
            label: 'Closed Cases',
            data: otherCase,
            fill: false,
            borderColor: '#9CCC65',
            backgroundColor: 'darkgreen',
          }
        ];

        this.chartData = {
          labels: this.cityList,
          datasets: tDS
        };

        this.dynoChartData = this.chartData;

        this.pieChartData = {
          labels: this.cityList,
          datasets: [
            {
              label: 'Open Cases',
              data: openCase,
              fill: false,
              borderColor: '#4bc0c0',
              backgroundColor: '#42A5F5',
            },
            {
              label: 'Closed Cases',
              data: otherCase,
              fill: false,
              borderColor: '#9CCC65',
              backgroundColor: 'darkgreen',
            }
          ]
        };
        this.assessorData = {
          labels: this.assessorList,
          datasets: [
            {
              label: 'Open Cases',
              data: openCaseAssessor,
              fill: false,
              borderColor: '#4bc0c0',
              backgroundColor: '#42A5F5',
            },
            {
              label: 'Closed Cases',
              data: otherCaseAssessor,
              fill: false,
              borderColor: '#9CCC65',
              backgroundColor: 'darkgreen',
            }
          ]
        };

        this.displayState.gridDiv = false;
        this.displayState.chartDiv = true;
        // this.displayState.chartDivDyno = true;
        this.getValueDiffData(caseIds, caseIdsByCity);
      });
    }
  getValueDiffData(caseIds: any[], caseIdsByCity: any[]) {
    this.utilService.doAudit(caseIds, 'case ids:');
    this.utilService.doAudit(caseIdsByCity, 'case ids, by city:');
    //
    const data = this.allSectionsData;  // source of data - ALL cases found for specified Roll Year
    //
    this.utilService.doAudit(data, 'data:');
    //
    const valDiffByCity = [];
    let cityIdx = -1;
    for (let i = 0; i < this.cityList.length; i++) {
      valDiffByCity[i] = 0;
    }
    //
    this.initChartDataset();
    // initialize all the cities to zero
    let caseObj: any = null, appId = '', appCtr = 0, city = '', valDiff = 0;
    for (let i = 0; i < data.length; i++) {
      caseObj = data[i];
      appId = caseObj.applicationId;
      valDiff = this.calcValDiff(caseObj);
      // this.utilService.doAudit(valDiff, 'valDiff for appId: ' + appId);
      appCtr = caseIds.indexOf(appId);
      // this.utilService.doAudit(appCtr, 'appCtr:');
      if (appCtr > -1) {
        cityIdx = caseIdsByCity[appCtr];
      } else {
        cityIdx = this.cityList.length - 1; // default to "Other"
      }
      valDiffByCity[cityIdx] = Number(valDiffByCity[cityIdx] + valDiff);
    }
    this.utilService.doAudit(valDiffByCity, 'valDiffByCity:');
    const tDS2 = [
      {
        label: 'Value Diff (in dollars)',
        data: valDiffByCity,
        fill: false,
        borderColor: '#4bc0c0',
        backgroundColor: '#42A5F5',
      },
    ];

    this.valueDiffData = {
      labels: this.cityList,
      datasets: tDS2
    };

    this.pieValueDiffData = {
      labels: this.cityList,
      datasets: [
        {
          label: 'Value Diff (in $)',
          data: valDiffByCity,
          fill: false,
          borderColor: '#4bc0c0',
          backgroundColor: '#42A5F5',
        },
      ]
    };

    this.displayState.valDiffDiv = true;
    this.displayState.workingDiv = false;
  }
  initChartDataset() {
    // populate chart data w/ empty dataset...
    const valDiffByCity = [];
    for (let i = 0; i < this.cityList.length; i++) {
      valDiffByCity[i] = 0;
    }
    this.valueDiffData = {
      labels: this.cityList,
      datasets: [
        {
          label: 'Value Diff (in US-dollars)',
          data: valDiffByCity,
          fill: false,
          borderColor: '#4bc0c0',
          backgroundColor: '#42A5F5',
        },
      ]
    };
    this.pieValueDiffData = {
      labels: this.cityList,
      datasets: [
        {
          label: 'Value Diff (in $)',
          data: valDiffByCity,
          fill: false,
          borderColor: '#4bc0c0',
          backgroundColor: '#42A5F5',
        },
      ]
    };
    //
    this.displayState.valDiffDiv = true;
    this.displayState.workingDiv = false;
    return;
  }
    calcValDiff(caseObj: any): any {
      const opinionVal = caseObj.tvOpinion ? caseObj.tvOpinion : 0;
      const appVal = caseObj.tvAssessor ? caseObj.tvAssessor : caseObj.tvApplicant;
      if (appVal && opinionVal) {
        return (appVal - opinionVal);
      } else { return 0; }
    }

    getReportData(caseYear: number) {
        const srcObj = {
            p0: '',
            p1: '',
            p2: ''
        };
        this.utilService.doAudit(srcObj, 'report search:');
        this.displayState.workingDiv = true;
        this.displayState.chartDiv = false;
        // get list of cases based on year they were filed (i.e. case #), NOT the Property Roll Year!
        this.caseService.getCaseListByYear(caseYear).subscribe(data => {
            this.utilService.doAudit(data, 'results from getCaseListByYear:');
            this.allSectionsData = data;
            this.chartOptions.title.text = 'Case Statistics for ' + caseYear + ' - by Status';
            this.valChartOptions.title.text = 'Value Differences for ' + caseYear;
            let caseObj: any = null;
            let city = '', stat = '', cityIdx = -1, statIdx = -1;
            const openCase = [], otherCase = [];
            // initialize city counters for each dataset (openCase, otherCase, etc)
            const caseIds = [], caseIdsByCity = [];
            for (let i = 0; i < this.cityList.length; i++) {
                openCase[i] = 0;
                otherCase[i] = 0;
            }
            // update city counters for each dataset...
            for (let i = 0; i < data.length; i++) {
                caseObj = data[i];
                city = data[i].city;
                stat = data[i].status;
                cityIdx = this.cityList.indexOf(city);
                if (cityIdx < 0) {
                    cityIdx = this.cityList.length - 1; // default to "Other"
                }
                if (stat === 'Open') {
                    openCase[cityIdx]++;
                } else {
                    otherCase[cityIdx]++;
                }
                caseIds.push(data[i].id);
                caseIdsByCity.push(cityIdx);

            }
            // this.utilService.doAudit(openCase, 'open cases totals');
            // this.utilService.doAudit(otherCase, 'other cases totals');
            this.chartSections = [];
            this.myChartSection = 1;
            const tDS = [
                {
                    label: 'Open Cases',
                    data: openCase,
                    fill: false,
                    borderColor: '#4bc0c0',
                    backgroundColor: '#42A5F5',
                },
                {
                    label: 'Closed Cases',
                    data: otherCase,
                    fill: false,
                    borderColor: '#9CCC65',
                    backgroundColor: 'darkgreen',
                }
            ];

            this.chartData = {
                labels: this.cityList,
                datasets: tDS
            };

            this.dynoChartData = this.chartData;

            this.pieChartData = {
                labels: this.cityList,
                datasets: [
                    {
                        data: openCase,
                        backgroundColor: this.dsColors,
                        hoverBackgroundColor: this.dsColors
                    },
                ]
            };

            this.displayState.gridDiv = false;
            this.displayState.chartDiv = true;
            // this.displayState.chartDivDyno = true;
            this.getValueDiffDataOLD(caseIds, caseIdsByCity);
        });
    }
    onChangeType() {
        this.utilService.doAudit(this.chartType, 'changed type to:');
        if (this.chartType !== 'pie') {
            this.dynoChartData = Object.assign({}, this.chartData);
            this.valueDiffData = Object.assign({}, this.valueDiffData);
            this.assessorData = Object.assign({}, this.assessorData);
        } else {
            this.dynoChartData = Object.assign({}, this.pieChartData);
            this.valueDiffData = Object.assign({}, this.pieValueDiffData);
            this.assessorData = Object.assign({}, this.assessorData);
        }
    }

    selectData(event) {
        this.utilService.doAudit(event, 'data selected:');
        this.utilService.doAudit(this.chartData.datasets[event.element._datasetIndex].data[event.element._index], 'item selected:');
    }

    selectValData(event) {
        this.utilService.doAudit(event, 'data selected:');
        this.utilService.doAudit(this.valueDiffData.datasets[event.element._datasetIndex].data[event.element._index], 'item selected:');
    }
    selectAssessorData(event) {
      this.utilService.doAudit(event, 'data selected:');
      this.utilService.doAudit(this.assessorData.datasets[event.element._datasetIndex].data[event.element._index], 'item selected:');
    }
    populateYearList() {
      const curYr = new Date().getFullYear();
      const yrList = [];
      for (let yr = curYr; yr > (curYr - 30); yr--)
      {
        yrList.push(yr);
      }
      this.yearList = yrList;
    }

  exportExcel() {
      this.utilService.exportExcel2(this.allSectionsData, [this.excelCols], 'cases-for-' + this.myYear);
      // this.utilService.exportExcel2(this.valueDiffData, [['ID', 'City', 'ValueDiff']], 'value-diff-list');
      return;
  }
  fixDateClosed() {
      const year = this.fixYear;
      if (year < 1990) {
        alert('invalid year!');
        return;
      }
      var ans = confirm('Are you sure you want to fix year ' + year + '?');
      if (ans == false) {
        return;
      }
      this.utilService.doAudit(year,'calling fixDateClosed for year:');
      this.statsService.fixDateClosed(year).subscribe(data => {
        // this.utilService.doAudit(data, 'results from fixDateClosed:');
        if (data) {
          alert('Results: ' + data);
        }
      });
  }
  onSelectReport(rep: any) {
    this.utilService.doAudit(rep, 'selected rep:');
    this.getReportData(this.myYear);
  }

  getValueDiffDataOLD(caseIds: any[], caseIdsByCity: any[]) {
    this.utilService.doAudit(caseIds, 'case ids:');
    this.utilService.doAudit(caseIdsByCity, 'case ids, by city:');
    //
    const valDiffByCity = [];
    let cityIdx = -1;
    for (let i = 0; i < this.cityList.length; i++) {
      valDiffByCity[i] = 0;
    }
    //
    const valObs = this.caseService.getValuesForCases(caseIds);
    this.utilService.doAudit(valObs, 'valObs');
    if (valObs == null) {
      // populate chart data w/ empty dataset...
      this.valueDiffData = {
        labels: this.cityList,
        datasets: [
          {
            label: 'Value Diff (in US-dollars)',
            data: valDiffByCity,
            fill: false,
            borderColor: '#4bc0c0',
            backgroundColor: '#42A5F5',
          },
        ]
      };

      this.pieValueDiffData = {
        labels: this.cityList,
        datasets: [
          {
            label: 'Value Diff (in $)',
            data: valDiffByCity,
            fill: false,
            borderColor: '#4bc0c0',
            backgroundColor: '#42A5F5',
          },
        ]
      };
      //
      this.displayState.valDiffDiv = true;
      this.displayState.workingDiv = false;
      return;
    }
    valObs.subscribe(data => {
      this.utilService.doAudit(data, 'results from getValuesForCases:');
      // initialize all the cities to zero

      let caseObj: any = null, appId = '', appCtr = 0, city = '', valDiff = 0;
      for (let i = 0; i < data.length; i++) {
        caseObj = data[i];
        appId = data[i].applicationId;
        valDiff = data[i].valueDifference;

        appCtr = caseIds.indexOf(appId);
        this.utilService.doAudit(appCtr, 'appCtr:');
        if (appCtr > -1) {
          cityIdx = caseIdsByCity[appCtr];
        } else {
          cityIdx = this.cityList.length - 1; // default to "Other"
        }
        valDiffByCity[cityIdx] = Number(valDiffByCity[cityIdx] + valDiff);
      }
      this.utilService.doAudit(valDiffByCity, 'valDiffByCity:');
      const tDS2 = [
        {
          label: 'Value Diff (in dollars)',
          data: valDiffByCity,
          fill: false,
          borderColor: '#4bc0c0',
          backgroundColor: '#42A5F5',
        },
      ];

      this.valueDiffData = {
        labels: this.cityList,
        datasets: tDS2
      };

      this.pieValueDiffData = {
        labels: this.cityList,
        datasets: [
          {
            label: 'Value Diff (in $)',
            data: valDiffByCity,
            fill: false,
            borderColor: '#4bc0c0',
            backgroundColor: '#42A5F5',
          },
        ]
      };

      this.displayState.valDiffDiv = true;
      this.displayState.workingDiv = false;
    });
  }

  onChangeSection() {
    const sectNum = this.myChartSection;
    this.utilService.doAudit(sectNum, 'changing report section to:');
    this.utilService.doAudit(this.allSectionsData[sectNum], 'section data:');
    this.displayState.workingDiv = true;
    // this.displayState.chartDiv = false;
    this.chartData = this.allSectionsData[sectNum];
    this.displayState.workingDiv = false;
    this.displayState.chartDiv = true;
  }
  getPieChartDataL() {
    this.pieChartData = {
      labels: ['A', 'B', 'C'],
      datasets: [
        {
          data: [300, 50, 100],
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
          ],
          hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
          ]
        }]
    };
  }

  getChartDataL() {
    // populate chartData array w/ test data...
    // let tLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
    const tLabels = this.cityList;
    const tDS = [
      {
        label: 'First Dataset',
        data: [65, 59, 80, 81, 56, 55, 40, 0, 15, 20, 150, 10],
        fill: false,
        borderColor: '#4bc0c0',
        backgroundColor: '#42A5F5',
      },
      {
        label: 'Second Dataset',
        data: [28, 48, 40, 19, 86, 27, 90, 20, 25, 35, 90, 120],
        fill: false,
        borderColor: '#565656',
        backgroundColor: '#9CCC65',
      }
    ];
    this.chartData = {
      labels: tLabels ,
      datasets: tDS
    };

    this.pieChartData = {
      labels: ['A', 'B', 'C'],
      datasets: [
        {
          data: [300, 50, 100],
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
          ],
          hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
          ]
        }]
    };
    this.chartOptions = {
      title: {
        display: true,
        text: 'Case Statistics for Year: ' + this.myYear,
        fontSize: 16,
      }
    };
  }


}
